module.exports = __webpack_public_path__ + "img/bg_login.5aba2b01.png";